"use client";

import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const services = [{
  title: "Full Bathroom Remodels",
  description: "Full bathroom remodels can include layout changes, showers, tubs, tile, flooring, vanities, fixtures, lighting, storage, and finish updates for Lakeland homes.",
  buttonText: "View Bathroom Remodels",
  href: "/bathroom-remodel/",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/full_bathroom_remodel.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/full_bathroom_remodel.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/full_bathroom_remodel.png-wvc-sizes",
    alt: "Full bathroom remodel in Lakeland FL"
  }
}, {
  title: "Shower Remodels",
  description: "Shower remodels can include walk-in showers, tile showers, glass shower doors, shower fixtures, storage niches, updated showerheads, and tub-to-shower conversion options.",
  buttonText: "View Shower Remodels",
  href: "/shower-remodel-lakeland-fl/",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/shower_remodel.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/shower_remodel.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/shower_remodel.png-wvc-sizes",
    alt: "Shower remodel in Lakeland FL"
  }
}, {
  title: "Tub and Shower Updates",
  description: "Tub and shower updates can include bathtub replacement, tub-to-shower conversions, shower surrounds, fixtures, tile, flooring, and accessibility updates.",
  buttonText: "View Tub Replacement",
  href: "/tub-replacement-lakeland-fl/",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/tub_shower_update.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/tub_shower_update.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/tub_shower_update.png-wvc-sizes",
    alt: "Tub replacement in Lakeland FL"
  }
}, {
  title: "Tile and Flooring",
  description: "Bathroom tile and flooring updates can include ceramic, porcelain, natural stone, shower tile, floor tile, wall tile, and water-resistant flooring options.",
  buttonText: "Request a Free Quote",
  href: "/contact/#request-your-bathroom-remodel-quote",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathroom_tile_flooring.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathroom_tile_flooring.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathroom_tile_flooring.png-wvc-sizes",
    alt: "Bathroom tile and flooring in Lakeland FL"
  }
}, {
  title: "Vanities and Fixtures",
  description: "Vanity and fixture updates can include sinks, faucets, mirrors, countertops, lighting, cabinet hardware, storage, and bathroom fixtures.",
  buttonText: "Request a Free Quote",
  href: "/contact/#request-your-bathroom-remodel-quote",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/vanity_fixtures_update.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/vanity_fixtures_update.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/vanity_fixtures_update.png-wvc-sizes",
    alt: "Bathroom vanity and fixture updates in Lakeland FL"
  }
}, {
  title: "Layout and Storage Updates",
  description: "Small bathroom layout and storage updates can help improve daily use with vanity space, shelving, cabinet storage, lighting, fixture placement, and layout changes.",
  buttonText: "View Small Bathroom Remodels",
  href: "/small-bathroom-remodel-lakeland-fl/",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/layout_storage_update.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/layout_storage_update.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/layout_storage_update.png-wvc-sizes",
    alt: "Small bathroom remodel in Lakeland FL"
  }
}];
const resourceLinks = [{
  title: "Bathroom Remodel Cost in Lakeland, FL",
  description: "Learn what can affect bathroom remodel cost, including shower, tub, tile, flooring, vanity, fixture, plumbing, and layout updates.",
  href: "/bathroom-remodel-cost-in-lakeland-fl/"
}, {
  title: "Shower Remodel Lakeland FL",
  description: "Review shower remodel options for Lakeland homes, including tile showers, walk-in showers, fixtures, doors, and tub-to-shower conversions.",
  href: "/shower-remodel-lakeland-fl/"
}, {
  title: "Tub Replacement Lakeland FL",
  description: "Explore bathtub replacement, tub and shower updates, surrounds, fixtures, tile, and flooring options for bathroom remodel projects.",
  href: "/tub-replacement-lakeland-fl/"
}, {
  title: "Small Bathroom Remodel Lakeland FL",
  description: "See small bathroom remodel options for layout updates, storage, lighting, vanities, showers, flooring, and fixtures.",
  href: "/small-bathroom-remodel-lakeland-fl/"
}, {
  title: "Bathroom Renovation Lakeland FL",
  description: "Learn about bathroom renovation options in Lakeland, including showers, tubs, tile, flooring, vanities, lighting, and layout updates.",
  href: "/bathroom-renovation-lakeland-fl/"
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};
export default function ServiceGrid() {
  return <section id="servicegrid" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center mb-12 md:mb-16">
          <motion.h2 initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl mb-4">
            Bathroom Remodeling Services for Lakeland Homes
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-sans text-lg text-muted-foreground">
            Explore common bathroom remodeling services for homes in Lakeland,
            FL and nearby Polk County areas, including full bathroom remodels,
            shower remodels, tub updates, tile, flooring, vanities, fixtures,
            lighting, storage, and layout improvements.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: "-100px"
      }} className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} data-index={index}>
              <Card className="h-full flex flex-col overflow-hidden border-border shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="aspect-video w-full overflow-hidden bg-muted">
                  <img src={service.image.src} data-wvc-srcset={service.image.srcset} data-wvc-sizes={service.image.sizes} alt={service.image.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>

                <CardHeader>
                  <CardTitle className="font-default text-xl">
                    {service.title}
                  </CardTitle>
                </CardHeader>

                <CardContent className="flex-grow">
                  <CardDescription className="font-sans text-base text-muted-foreground">
                    {service.description}
                  </CardDescription>
                </CardContent>

                <CardFooter className="pt-4 pb-6">
                  <Button asChild className="w-full group" variant="default">
                    <Link to={service.href}>
                      {service.buttonText}
                      <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </motion.div>)}
        </motion.div>

        <div className="mt-20 md:mt-24">
          <div className="mx-auto max-w-3xl text-center mb-10 md:mb-12">
            <motion.h2 initial={{
            opacity: 0,
            y: -20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl mb-4">
              Bathroom Remodel Resources in Lakeland, FL
            </motion.h2>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="font-sans text-lg text-muted-foreground">
              Explore helpful bathroom remodel resources and service pages for
              Lakeland, FL homeowners, including bathroom remodel cost, shower
              remodels, tub replacement, small bathroom remodels, and bathroom
              renovation options.
            </motion.p>
          </div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
          once: true,
          margin: "-100px"
        }} className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {resourceLinks.map((resource, index) => <motion.div key={resource.href} variants={itemVariants} data-index={index}>
                <Card className="h-full border-border shadow-sm hover:shadow-md transition-shadow duration-300">
                  <CardHeader>
                    <CardTitle className="font-default text-xl">
                      <Link to={resource.href} className="transition-colors hover:text-primary">
                        {resource.title}
                      </Link>
                    </CardTitle>
                  </CardHeader>

                  <CardContent>
                    <CardDescription className="font-sans text-base text-muted-foreground">
                      {resource.description}
                    </CardDescription>
                  </CardContent>

                  <CardFooter className="pt-4 pb-6">
                    <Button asChild className="w-full group" variant="outline">
                      <Link to={resource.href}>
                        View Page
                        <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}